import React, { useState, useEffect, useContext } from 'react';

import { UserContext } from '../../../Context/UserContextProvider';

import Button from '@mui/material/Button';

// Styles
import styles from "./../UserManagment.module.css";
import { Link } from 'react-router-dom';

const UserManagmentChatDetailBox = ({ chatData, changeHandler, sendMessage, inputRef, isUser, sendMessageKeyboadrd }) => {
    const [chatRef, setChatRef] = useState(null);
    const { userData } = useContext(UserContext);

    useEffect(() => {
        // Scroll to the bottom of the chat window
        chatRef?.scrollIntoView({ behavior: "smooth" });
        // console.log(chatData)
    }, [chatData?.messageContents, chatRef]);

    return (
        <div dir="rtl" className={`mx-4 mt-3 px-2 pb-0 pt-3  ${styles.consultanttextreportchats_container} ${isUser && "w-100"}`} ref={ref => setChatRef(ref)}>
            {chatData?.estateDto?.slug ?
                <Link to={{
                    pathname: `/فایل/${chatData?.estateDto?.slug}`,
                    state: {
                        state: chatData?.estateDto
                    }
                }} className={`w-100 text-end mb-3 ${styles.file_detail}`}>
                    <div className="w-100 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center justify-content-center">
                            <img className={styles.card_img} loading="lazy" src={`https://backdev.azrmelk.com/images/States/${chatData?.estateDto?.imageUrl}`} alt="card-img" />
                            <div className={styles.file_title}>
                                {chatData?.estateDto?.title}
                            </div>
                        </div>
                        <Link className={`ms-2 ${styles.link_icon_text}`} to={{
                            pathname: `/فایل/${chatData?.estateDto?.slug}`,
                            state: {
                                state: chatData?.estateDto
                            }
                        }}>
                            مشاهده فایل مربوطه
                            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" className='me-1'>
                                <path fillRule="evenodd" clipRule="evenodd" d="M7.17475 11.6591C6.84524 11.9886 6.31101 11.9886 5.9815 11.6591L0.919005 6.59662C0.589499 6.26712 0.589499 5.73288 0.919005 5.40338L5.9815 0.340879C6.31101 0.0113729 6.84524 0.011373 7.17475 0.340879C7.50425 0.670383 7.50425 1.20462 7.17475 1.53412L3.55262 5.15625L12.4844 5.15625C12.9504 5.15625 13.3281 5.53401 13.3281 6C13.3281 6.46599 12.9504 6.84375 12.4844 6.84375L3.55262 6.84375L7.17475 10.4659C7.50425 10.7954 7.50425 11.3296 7.17475 11.6591Z" fill="#21409A" />
                            </svg>
                        </Link>
                    </div>
                </Link>
                :
                <></>
            }

            <AlreadyChat chatData={chatData} userData={userData} />

            {/* Message Text Input Box */}
            <div className={styles.send_message_container}>
                <input className={`w-100 p-3 ${styles.message_input_user_managment_chat_detail}`} type="text" ref={inputRef} onChange={changeHandler} onKeyDown={sendMessageKeyboadrd} placeholder="پیام خود را بنویسید..." />
                <Button variant="text" onClick={sendMessage}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send pointer" viewBox="0 0 16 16">
                        <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                    </svg>
                </Button>
            </div>

        </div>
    )

}

function AlreadyChat({ chatData, userData }) {
    const sortedMessages = chatData?.messageContents.sort((a, b) => new Date(a.creationDate) - new Date(b.creationDate))
    const sorted = sortedMessages.sort((a, b) => new Date(a.createDate) - new Date(b.createDate))
    const daysArray = sorted.reduce((acc, curr) => {
        const date = curr.createDate;
        const dayIndex = acc.findIndex(day => day.date === date);
        if (dayIndex >= 0) {
            acc[dayIndex].messages.push(curr);
        } else {
            acc.push({
                date,
                messages: [curr]
            });
        }
        return acc;
    }, []);

    return (
        <>
            {daysArray == "" ?
                <div style={{ minHeight: "320px" }}></div>
                :
                daysArray?.map((item, i) => (
                    <div key={i} className={`px-3 ${styles.consultanttextreportchats_row}`}>
                        <span className={`d-flex justify-content-center align-items-center my-3 mx-auto ${styles.consultanttextreportchats_date}`}>
                            {item.date?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                        </span>

                        <Messages messages={item.messages} chatData={chatData} userData={userData} />
                    </div>
                ))
            }
        </>
    )
}

function Messages({ messages, chatData, userData }) {
    return (
        <>
            {messages?.map((item) => (
                item.userId === userData?.id ?
                    <div dir="rtl" key={item.id} className={`d-flex align-items-center position-relative my-4 ${styles.box_user_managment_chat_detail}`}>
                        <div className={`text-left ${styles.text_container}`}>
                            <p className={`d-flex flex-wrap bg-white mb-0 mx-2 px-3 py-3 text-right position-relative ${styles.text_user_managment_chat_detail}`} style={{ direction: isPersian(item.text) ? "rtl" : "ltr" }}>
                                {item.text}
                                {item.isSeen ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1976d2" className={`bi bi-check2-all ${styles.check_message}`} viewBox="0 0 16 16">
                                        <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z" />
                                        <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z" />
                                    </svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1976d2" className={`bi bi-check2 ${styles.check_message}`} viewBox="0 0 16 16">
                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                                    </svg>
                                }
                            </p>
                            <span style={{ transform: "translate(15px, -15px)" }} className={`mx-2 ${styles.time_user_managment_chat_detail}`}> {item.createTime?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])} </span>
                        </div>
                    </div>
                    :
                    <div dir="ltr" key={item.id} className={`d-flex align-items-center position-relative my-4 ${styles.box_user_managment_chat_detail}`}>
                        {chatData.senderId === item.userId ?
                            <img className={`ms-1 ${styles.avatar_user_managment_chat_detail}`} src={`https://backdev.azrmelk.com/images/users/avatar/${chatData.senderAvatar}`} loading='lazy' alt="avatar-chat-img" />
                            :
                            <img className={`ms-1 ${styles.avatar_user_managment_chat_detail}`} src={`https://backdev.azrmelk.com/images/users/avatar/${chatData.recieverAvatar}`} loading='lazy' alt="avatar-chat-img" />
                        }
                        <div className={`text-right ${styles.text_container}`}>
                            <p className={`d-flex flex-wrap mb-0 mx-2 px-3 py-3 text-right position-relative ${styles.text_user_managment_chat_detail}`} style={{ direction: isPersian(item.text) ? "rtl" : "ltr", background: "#ECECEC" }}>
                                {item.text}
                            </p>
                            <span style={{ transform: "translate(-15px, -15px)" }} className={`mx-2 ${styles.time_user_managment_chat_detail}`}>{item.createTime?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}</span>
                        </div>
                    </div>
            ))}
        </>
    )

    function isPersian(params) {
        var arabicPattern = /[\u0600-\u06FF]/;
        return (
            arabicPattern.test(params)
        )

    }
}


export default React.memo(UserManagmentChatDetailBox);